import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import CommentPost from 'flarum/forum/components/CommentPost';
import SummaryModal from './components/SummaryModal';
import AiBotPane from './components/AiBotPane';
const t = k => app.translator.trans('ernestdefoe-ai-helper.forum.' + k);

/** The post's author when (and only when) they are the configured bot account. */
const botUser = post => {
  var _app$forum$attribute, _post$user;
  const id = parseInt(String((_app$forum$attribute = app.forum.attribute('aiHelperBotId')) != null ? _app$forum$attribute : ''), 10);
  if (!id) return null;
  const user = post == null || (_post$user = post.user) == null ? void 0 : _post$user.call(post);
  return user && String(user.id()) === String(id) ? user : null;
};
app.initializers.add('ernestdefoe-ai-helper', () => {
  // The assistant's posts carry a distinctive pane instead of the plain side
  // avatar (mirrors how armory character panes replace it); group badges
  // re-flow beside the username via the Post--ai-bot class + CSS.
  extend(CommentPost.prototype, 'sideItems', function (items) {
    const user = botUser(this.attrs.post);
    if (user) {
      items.add('aiBot', AiBotPane.component({
        user
      }), 90);
      if (items.has('avatar')) items.remove('avatar');
    }
  });
  extend(CommentPost.prototype, 'classes', function (classes) {
    if (botUser(this.attrs.post)) classes.push('Post--ai-bot');
  });

  // "Summarize" in a discussion's controls dropdown — registered users only,
  // and only when the assistant is enabled.
  extend(DiscussionControls, 'userControls', function (items, discussion) {
    if (!app.forum.attribute('aiHelperEnabled') || !app.session.user) {
      return;
    }
    items.add('aiHelperSummarize', Button.component({
      icon: 'fas fa-robot',
      onclick: () => app.modal.show(SummaryModal, {
        discussion
      })
    }, t('summarize')), -10);
  });
});